/**
 * Reine Logik der Sammel-Link-Seite (#/unterweisungen/<token>): was auf einer
 * Karte unter dem Titel steht. Ohne React, getestet in sammelLinkLogic.test.ts.
 */
import type { SammelLinkPublic } from '../../../services/sifa/types';
import { dauerText } from './teilnahmeSeiteLogic';

type SammelEintrag = SammelLinkPublic['unterweisungen'][number];

const anzahl = (n: number, eins: string, viele: string): string => `${n} ${n === 1 ? eins : viele}`;

/**
 * „ca. 15 Minuten · 4 Abschnitte · 5 Fragen" — Dauer nur mit Angabe, null
 * Fragen werden nicht erwaehnt (eine Unterweisung ohne Abfrage gibt es).
 */
export const kartenInfo = (u: Pick<SammelEintrag, 'dauerMin' | 'abschnitte' | 'fragen'>): string =>
  [
    dauerText(u.dauerMin),
    anzahl(Math.max(0, u.abschnitte || 0), 'Abschnitt', 'Abschnitte'),
    u.fragen > 0 ? anzahl(u.fragen, 'Frage', 'Fragen') : '',
  ]
    .filter(Boolean)
    .join(' · ');
